import { actionTypes, routesNames } from '@/core/constants'
import store from '@/core/store'

export default {
	async beforeRouteLeave(to, from, next) {
		if (to.name !== routesNames.PEDIDO.ACESSAR_ITENS_VIEW) {
			await store.dispatch(actionTypes.COMUM.ATUALIZAR_SESSAO, 0)
		}
		next()
	},
}
